import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.869225 9.9999C0.646743 9.9999 0.424262 9.91504 0.254564 9.74534C-0.0848545 9.40584 -0.0848545 8.85543 0.254564 8.51602L8.5159 0.254678C8.85532 -0.0848248 9.40572 -0.0848248 9.74522 0.254678C10.0846 0.594096 10.0846 1.14458 9.74522 1.484L1.48389 9.74534C1.31418 9.91505 1.09171 9.9999 0.869225 9.9999ZM9.13077 9.99981C8.90829 9.99981 8.68581 9.91496 8.51611 9.74526L0.254564 1.48392C-0.0848545 1.1445 -0.0848545 0.594013 0.254564 0.254595C0.593982 -0.0848228 1.14447 -0.0849074 1.48389 0.254595L9.74544 8.51593C10.0849 8.85544 10.0849 9.40584 9.74544 9.74526C9.57573 9.91505 9.35326 9.9999 9.13077 9.9999V9.99981Z"
      fill="black"
    />
  </svg>
);
export default SVGComponent;
